export default "__VITE_ASSET__CHJ96ous__"